export default __webpack_public_path__ + "assets/images/5d68c6075b1894989237fc67792bda81.svg";